import React, { Component } from "react";

function GenericRow(props: any) {
	const cells = props.row.map((cell: any, index: number) => (
		<td key={index}>{cell}</td>
	));
	return <tr>{cells}</tr>;
}
class GenericTable extends Component<any> {
	render() {
		const theads = this.props.columns.map((column: any, index: number) => (
			<th scope="col" key={index}>
				{column}
			</th>
		));
		const tbody = this.props.data.map((row: any, index: number) => (
			<GenericRow row={row} key={index}></GenericRow>
		));

		return (
			<React.Fragment>
				<div className="container-fluid my-3">
					<div className="table-responsive-md">
						<table className="table table-hover table-striped table-sm">
							<thead>
								<tr>{theads}</tr>
							</thead>
							<tbody>{tbody}</tbody>
						</table>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
export { GenericTable };
